import React, {PropTypes} from 'react';
import HomeTopBar from './nav/TopBar';

import {FormattedMessage} from 'react-intl';

class Error extends React.Component {
  static propTypes = {
    city: PropTypes.string,
    country: PropTypes.string,
    lang: PropTypes.string,
    logo: PropTypes.string,
    restaurant: PropTypes.string,
    wine_slug: PropTypes.string
  };

  render() {
    const anchor_url = 'https://picklymenu.com/';

    return (
      <div>
        <HomeTopBar restaurant={this.props.restaurant} name="Pickly"
                    logo={this.props.logo} city={this.props.city}
                    country={this.props.country} lang={this.props.lang} wine_slug={this.props.wine_slug}
                    view="error"/>
        <div className="error-wrapper">
          <div className="error-content">
            <FormattedMessage id="error_home_title1">
              {(message) => <h2>{message}</h2>}
            </FormattedMessage>
            <FormattedMessage id="error_home_title2">
              {(message) => <h4>{message}</h4>}
            </FormattedMessage>
            <FormattedMessage id="error_home_text">
              {(message) => <p>{message}</p>}
            </FormattedMessage>
            <a className="btn secondary-btn big-btn"
               href={anchor_url}>
              <FormattedMessage id="error_home_link">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Error;




/** WEBPACK FOOTER **
 ** ./src/components/Error.js
 **/